import AgendaView from './agenda.view';
import { AgendaProvider } from './providers/agenda.provider';

export default function Agenda() {
  return (
    <AgendaProvider>
      <AgendaView />
    </AgendaProvider>
  );
}
